import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
const UiButton = ({
    add,
    style,
    onClick,
    children,
    ...restProps
}) => {
    let icon = null;

    if (add) { icon = <PlusOutlined /> }

    return <div>
        <Button style={style}
            icon={icon}
            onClick={onClick}
            {...restProps}>
            {children}</Button>
    </div>
};
export default UiButton